import React from 'react';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, FormHelperText } from '@mui/material';

interface SelectStatusTarefaProps {
    value: string;
    onChange: (value: string) => void;
    label?: string;
    fullWidth?: boolean;
    error?: boolean;
    helperText?: string;
    required?: boolean;
}

const SelectStatusTarefa: React.FC<SelectStatusTarefaProps> = ({
    value,
    onChange,
    label = "Status",
    fullWidth = true,
    error = false,
    helperText = '',
    required = false,
}) => {
    const handleChange = (e: SelectChangeEvent<string>) => {
        onChange(e.target.value);
    };

    return (
        <FormControl fullWidth={fullWidth} color="secondary" error={error} required={required}>
            <InputLabel>{label}</InputLabel>
            <Select
                value={value}
                label={label}
                onChange={handleChange}
            >
                <MenuItem value="Pendente">Pendente</MenuItem>
                <MenuItem value="Em Andamento">Em Andamento</MenuItem>
                <MenuItem value="Finalizada">Finalizada</MenuItem>
            </Select>
            {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
    );
};

export default SelectStatusTarefa;
